export function awaitWindowVariable(context, variable, callback) {
  //checks for when a global window variable has been populated without the use of set timeouts
  //context: the location where the variable should be populated, i.e. window.Brooklinen
  //variable: the name of the variable that will be dynamically populated
  //callback: optional. the function that should fire once the variable has been populated

  if (context[variable]) {
    if (callback) callback();
  } else {
    Object.defineProperty(context, variable, {
      configurable: true,
      enumerable: true,
      get: function () {
        return this[`_${variable}`];
      },
      set: function (val) {
        this[`_${variable}`] = val;
        if (callback) callback();
      },
    });
  }

  return context[variable];
}

export function loadCart() {
  const initOverlayBackground = new CustomEvent('init-overlay', {
    detail: 'cart',
  });
  window.dispatchEvent(initOverlayBackground);
}

export function closeCart() {
  const closeOverlayBackground = new CustomEvent('close-overlay', {
    detail: 'cart',
  });
  window.dispatchEvent(closeOverlayBackground);
}

export function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

const trapFocusHandlers = {};

export function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

export function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

export function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

export function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

export function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

export function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

export function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

//returns browser's scrollbar width as a value in PX.
//used primarily for readjusting page widths when overlays are active on the screen
export function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

//shows custom error messages on PDP based on quantity rules defined in product's JSON
export function handleErrors(isError, errorMsg, isCart) {
  if (isError) {
    document.querySelector('.product-form__error-message-wrapper').removeAttribute('hidden');
    document.querySelector('.product-form__error-message-wrapper .caption').innerHTML = errorMsg;
    document.querySelector('quantity-input .quantity__input').classList.add('has-errors');
  } else if (!isCart) {
    document.querySelector('.product-form__error-message-wrapper').setAttribute('hidden', true);
    document.querySelector('.product-form__error-message-wrapper .caption').innerHTML = '';
    document.querySelector('quantity-input .quantity__input').classList.remove('has-errors');
  }
}

export function emailValidate(input) {
  // validate email input
  const isValid = input.checkValidity();
  const isEmpty = input.value.length === 0;
  input.dataset.validate = !isEmpty ? isValid : false;
  return input.dataset.validate;
}
export function noRoundDecimal(price) {
  return Math.floor(price * 100) / 100.0;
}

/*
 * Add in img and svg assets to the story module ( or anywhere )
 * This is based on the functionality to add breakpoints in copy
 * it's currently set up to handle the marlow logo, review style five stars,
 * and the Rich and Vicki signature as these are the legacy assets that we have to account for.
 *
 */

export function initCustomAsset(text) {
  const assets = [
    {
      name: 'marlow',
      src: '<svg width="50" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m13.495 10.645-.736-6.927c-.062-.535-.092-.857-.092-1.028 0-.706.506-.58.506-1.087 0-.2-.138-.367-.414-.367-.276 0-.598.046-1.133.046-.581 0-.765-.046-1.103-.046-.306 0-.476.167-.476.384 0 .568.535.397.535 1.074 0 .184-.063.46-.122.673L8.99 8.254 7.413 3.35c-.063-.23-.122-.506-.122-.674 0-.643.552-.505.552-1.057 0-.2-.168-.384-.443-.384-2.726 0-3.028-.483-4.953-.483-.82 0-1.691.295-2.148.975a1.839 1.839 0 0 0-.203 1.59c.18.522.617.952 1.143 1.123.275.092.59.112.853-.017.263-.128.427-.328.401-.617-.033-.384-.387-.427-.43-.942-.026-.329.072-.555.299-.74.394-.318 1.507-.364 2.075.198.486.48.621.959.51 2.512l-.066.594-.578 5.17c-.092.857-.828.719-.828 1.24 0 .26.138.398.443.398.247 0 .536-.046.828-.046.292 0 .614.046.95.046.291 0 .488-.138.488-.397 0-.535-.706-.397-.706-1.012 0-.154.017-.321.046-.597l.522-5.104 1.915 5.79c.154.43.306.552.598.552.322 0 .506-.154.627-.535l1.75-5.685.444 5.07c.016.184.03.385.03.552 0 .598-.707.46-.707.995 0 .247.2.368.506.368.351 0 .828-.046 1.396-.046s.965.046 1.241.046c.292 0 .43-.154.43-.368 0-.565-.69-.41-.781-1.221zM21.324 11.042c-.72-.2-.811-.552-.89-1.363l-.246-2.591c-.138-1.455-.644-2.742-2.391-2.742-.936 0-1.747.367-2.315 1.057-.2.214-.322.46-.322.673 0 .23.154.385.384.385.121 0 .26-.046.535-.26.322-.305.66-.552 1.074-.552.982 0 1.12 1.271 1.196 1.977l.016.214a2.628 2.628 0 0 0-1.166-.26c-1.547 0-2.466 1.104-2.466 2.45 0 1.363.903 2.345 2.16 2.345.89 0 1.548-.43 1.915-.995.276.614.798.936 1.35.936.92 0 1.409-.614 1.409-.982.003-.154-.105-.246-.243-.292zm-3.708.138c-.535 0-.936-.552-.936-1.363 0-.844.43-1.304 1.028-1.304.214 0 .506.076.736.23l.167 1.84c-.213.35-.58.597-.995.597zM26.52 4.346c-.92 0-1.656.844-1.978 1.993V5.065c0-.26-.03-.66-.367-.66-.168 0-.26.046-1.058.476-.857.46-1.15.627-1.15.92 0 .58.644.2.644 1.149v3.507c0 1.18-.568.89-.568 1.396 0 .184.122.384.414.384.26 0 .506-.046 1.12-.046.673 0 .965.046 1.254.046.276 0 .414-.2.414-.384 0-.552-.706-.213-.706-1.396V8.986c0-1.96.552-2.85 1.058-2.85.2 0 .384.121.597.597.122.276.247.444.46.444.23 0 .338-.155.443-.444.26-.719.444-1.241.444-1.593.003-.489-.503-.794-1.022-.794zM30.362 10.457v-9.36c0-.43-.138-.597-.384-.597-.138 0-.247.03-1.074.476-.89.476-1.15.627-1.15.92 0 .581.69.184.69 1.15v7.415c0 1.179-.614.857-.614 1.395 0 .184.121.385.43.385.26 0 .522-.046 1.133-.046.627 0 .903.046 1.166.046.292 0 .414-.214.414-.385.003-.538-.611-.216-.611-1.399zM34.966 4.224c-2.115 0-3.402 1.898-3.402 4.23 0 2.45 1.27 4.046 3.231 4.046 2.07 0 3.386-1.915 3.386-4.197.003-2.457-1.254-4.079-3.215-4.079zm.046 7.245c-.811 0-1.38-1.442-1.38-3.616 0-1.747.385-2.604 1.104-2.604.798 0 1.363 1.455 1.363 3.645 0 1.75-.351 2.575-1.087 2.575zM48.848 4.467c-.2 0-.522.046-.782.046-.322 0-.522-.046-.765-.046-.322 0-.49.155-.49.384 0 .43.569.385.569 1.028 0 .214-.063.536-.155.874l-.873 3.494-.874-3.494c-.075-.352-.167-.736-.167-.903 0-.644.581-.568.581-.995 0-.23-.167-.385-.49-.385-.337 0-.597.046-1.132.046-.66 0-.936-.046-1.212-.046-.2 0-.384.138-.384.368 0 .414.49.339.752 1.363l.046.155-1.196 3.891-.873-3.494c-.076-.322-.154-.673-.154-.844 0-.673.476-.644.476-1.058 0-.246-.2-.384-.506-.384-.322 0-.552.046-1.133.046-.627 0-1.012-.046-1.304-.046-.246 0-.397.138-.397.368 0 .46.568.322.827 1.363l1.41 5.3c.137.552.259.798 1.103.798s.949-.213 1.12-.798l1.057-3.507.903 3.478c.154.627.306.827 1.104.827.781 0 .935-.183 1.087-.81L48.404 6.2c.26-1.011.858-.903.858-1.363 0-.216-.155-.37-.414-.37z" fill="#0F1528"/></svg>',
    },
    {
      name: 'five-star',
      src: '<svg xmlns="http://www.w3.org/2000/svg" width="119" height="20" viewBox="0 0 119 20" fill="none"><path d="M10.6919 0L13.6907 5.95492L20.3962 6.90983L15.5441 11.5451L16.6895 18.0902L10.6919 15L4.69438 18.0902L5.83982 11.5451L0.987684 6.90983L7.69316 5.95492L10.6919 0Z" fill="#E3AD7C"/><path d="M35.1818 0L38.1805 5.95492L44.886 6.90983L40.0339 11.5451L41.1793 18.0902L35.1818 15L29.1842 18.0902L30.3296 11.5451L25.4775 6.90983L32.183 5.95492L35.1818 0Z" fill="#E3AD7C"/><path d="M59.6666 0L62.6653 5.95492L69.3708 6.90983L64.5187 11.5451L65.6641 18.0902L59.6666 15L53.669 18.0902L54.8144 11.5451L49.9623 6.90983L56.6678 5.95492L59.6666 0Z" fill="#E3AD7C"/><path d="M84.1564 0L87.1551 5.95492L93.8606 6.90983L89.0085 11.5451L90.1539 18.0902L84.1564 15L78.1588 18.0902L79.3042 11.5451L74.4521 6.90983L81.1576 5.95492L84.1564 0Z" fill="#E3AD7C"/><path d="M108.646 0L111.645 5.95492L118.35 6.90983L113.498 11.5451L114.644 18.0902L108.646 15L102.649 18.0902L103.794 11.5451L98.9419 6.90983L105.647 5.95492L108.646 0Z" fill="#E3AD7C"/>',
    },
    {
      name: 'signature',
      src: 'https://cdn.shopify.com/s/files/1/0767/1146/1143/files/rich-vicki-signature.png?v=1714414405',
    },
    {
      name: 'trademark',
      src: '<span class="trademark">',
    },
    {
      name: 'endtrademark',
      src: '</span>',
    },
    {
      name: 'posttrademark',
      src: '<span class="posttrademark">',
    },
    {
      name: 'endposttrademark',
      src: '</span>',
    },
  ];

  let context = text ? text : document.body.innerHTML;

  assets.forEach((asset) => {
    if (asset.name == 'signature') {
      context = context.replaceAll(`*${asset.name}*`, `<img alt="Signature" src=${asset.src}/>`);
    } else {
      context = context.replaceAll(`*${asset.name}*`, `${asset.src}`);
    }
  });

  return text
    ? context
    : new Promise((resolve) => {
        resolve('resolved');
      });
}

export const removeSoldOutFromText = (string) => string.replace('(Sold out)', '').trim();

export function initCustomModalTriggers() {
  const triggerModal = (modal) => {
    switch (modal) {
      case 'chat':
        window.Gladly?.show();
        break;
      default:
        break;
    }
  };
  document.querySelectorAll(`[href^="#modal-"`).forEach((btn) => {
    btn.addEventListener('click', () => {
      triggerModal(btn.getAttribute('href')?.split('-')[1]);
    });
  });
}

export function renderModules(modules) {
  modules.forEach((module) => {
    if (!module.context) {
      module.component();
    } else if (module.context.length > 0) {
      module.context?.forEach((moduleContext) => {
        module.component(moduleContext);
      });
    }
  });
}

export function generatePreviewLinks() {
  let url = new URL(window.location.href);
  url.searchParams.delete('preview_theme_id');
  url.searchParams.delete('blCookieSet');
  url.searchParams.append('preview_theme_id', window.Shopify?.theme?.id);
  window.Brooklinen.dev = window.Brooklinen.dev || {};
  window.Brooklinen.dev['preview'] = url.href;
  getCookies('_bl_dev__').forEach((cookie) => {
    url.searchParams.append('blCookieSet', cookie);
  });
  window.Brooklinen.dev['cookiePreview'] = url.href;
  function getCookies(match) {
    let cookieParts = document.cookie.split(';'),
      cookies = {};

    for (let i = 0; i < cookieParts.length; i++) {
      let name_value = cookieParts[i],
        equals_pos = name_value.indexOf('='),
        name = name_value.slice(0, equals_pos).trim(),
        value = name_value.slice(equals_pos + 1);
      cookies[name] = value;
    }
    return Object.keys(cookies).filter((val) => val.includes(match));
  }
}

export function updateBtnClickArea() {
  document.querySelectorAll('div.button').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (e.target.nodeName != 'A' && !e.target.getAttribute('href')) {
        if (btn.querySelector('a[href]')) {
          btn.querySelector('a[href]').click();
        }
      }
    });
  });
}

export function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// https://learnersbucket.com/examples/interview/capture-product-visible-on-viewport-when-user-stops-scrolling/
// Helper function to check if element is in viewport.
export function isInViewport(elem) {
  const bounding = elem.getBoundingClientRect();
  return bounding.top >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

//helper function to check if element is only PARTIALLY visible in viewport.
//https://www.30secondsofcode.org/js/s/element-is-visible-in-viewport/
export function elementIsVisibleInViewport(el, partiallyVisible = false) {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  return partiallyVisible ? (top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight) : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
}

//function that returns the number of unique instances of a specific product in a user's cart.
//used on PDPs to determine if a user has hit or exceeded the limit for max bundles
export function getCartInstances(title, cart) {
  return cart.items.filter((item) => {
    const bundleItemTitle = item.product_title.replace(' Checkout', '');
    return bundleItemTitle == title;
  }).length;
}

async function sha256(email) {
  if (!email) return;
  const normalizedEmail = email?.toLowerCase();
  const msgUint8 = new TextEncoder().encode(normalizedEmail);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashedEmail = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  return hashedEmail;
}

export function emailDlPush() {
  const dataLayer = window.dataLayer;

  return dataLayer.forEach((layer) => {
    if (layer.event === 'dl_user_data') {
      const email = layer.user_properties.customer_email;

      sha256(email)
        .then((hashedEmail) => {
          dataLayer.push({
            event: 'dl_hashed_email',
            hashedEmail: hashedEmail,
          });
        })
        .catch((err) => {
          console.error('SHA-256 hashing error:', err);
        });
    }
  });
}

//BS-7229: Fire custom event to close/hide/show UGC Video in DY.
//action takes one of three arguments: 'show', 'hide', 'close'
//The UGC Video template, including CSS/JS/HTML, lives in DY.

export function ugcVideo(action) {
  const ugcVideoEvent = new CustomEvent(`dy:ugcVid:${action}`, {
    detail: {},
    bubbles: true,
    cancelable: true,
  });
  document.dispatchEvent(ugcVideoEvent);
}

export function createJsonScriptTag(jsonData, elementId) {
  const jsonString = JSON.stringify(jsonData);
  const scriptElement = document.createElement('script');
  scriptElement.type = 'application/json';
  scriptElement.textContent = jsonString;
  scriptElement.id = elementId;
  document.head.appendChild(scriptElement);
}

export function sendDYAudiences() {
  function waitForObject(condition, callback) {
    return new Promise((resolve, reject) => {
      const intervalId = setInterval(() => {
        if (window.DY?.Audiences?.getUserAudiences()?.length > 0) {
          const audienceIds = window.DY?.Audiences?.getUserAudiences();
          const audiences = {
            audiences: audienceIds,
          };
          clearInterval(intervalId);
          resolve(audiences);
        }
      }, 100);
    });
  }
  waitForObject().then((obj) => {
    //a hardcoded list of DY audience IDs mapped to their respective audience names.
    const audienceLibrary = [
      { id: '2532880', audience_name: 'High Intent, Non-Purchaser' },
      { id: '2532878', audience_name: 'Medium Intent, Non-Purchaser' },
      { id: '2532874', audience_name: 'Low Intent, Non-Purchaser' },
      { id: '2532675', audience_name: 'Purchasers' },
    ];

    //exposing the audience IDs to the front end via a JSON object so audience info can be targeted and tracked easier
    createJsonScriptTag(obj, 'dy-audiences');

    //cross reference the user's audience IDs with the audience library, then send info to heap
    const matchedAudience = audienceLibrary.filter((audience) => obj.audiences.includes(audience.id))?.[0];
    heap.addUserProperties({
      dy_audience_id: matchedAudience.id,
      dy_audience_name: matchedAudience.audience_name,
    });
  });
}
